<div class="contenido404">
  <div class="data">
    <h2 i18n>Error 404</h2>
    <p i18n>No encontramos lo que buscas!</p>
    <br /><br />
    <div class="acciones">
      <button routerLink="/" mat-stroked-button>
        <mat-icon i18n>arrow_back</mat-icon>
        Volver al inicio
      </button>
      &nbsp;
      <button mat-stroked-button>
        <mat-icon i18n>help_outline</mat-icon>
        Centro de ayuda
      </button>
    </div>
  </div>
</div>
